import { IContacto, defaultIContacto } from "../ioip/sdk/base";

export interface IContactoExtended extends IContacto {
    //AutorizaTratamientoDatosPersonales: boolean;
    IdPreguntaSecreta: number;
    Password: string;
    Password2: string;
    RespuestaSecreta: string;
    Email2: string;
    PrimerNombre: string;
    SegundoNombre: string;
    PrimerApellido: string;
    SegundoApellido: string;
    IdTipoSolicitante?: number;
}


export function defaultIContactoExtended(): IContactoExtended {
    return {
        ...defaultIContacto(),
        //AutorizaTratamientoDatosPersonales: false,
        IdPreguntaSecreta: 0,
        Password: '',
        Password2: '',
        RespuestaSecreta: '',
        Email2: '',
        PrimerNombre: '',
        SegundoNombre: '',
        PrimerApellido: '',
        SegundoApellido: ''
    }
}